module.exports = __webpack_public_path__ + "static/media/nz-dollar.57b07f96.svg";